// extracted by mini-css-extract-plugin
export default {"notifications":"ab0c85","notifications__empty":"a3951d","notifications__title":"f6f02f","notifications__subtitle":"dfd1e6"};